import axios from 'axios';

export default axios.create({
    baseURL:"https://roadhouse-wingsbackend-production.up.railway.app/api/v1",
    // baseURL:"https://rhw-backend-ecjw.onrender.com/api/v1",
    // baseURL:"http://localhost:8091/api/v1",
});

